export const Config = {
    //api: 'http://localhost:3000/api/v1',
    //api: 'https://dev-api.mylighthouse.co',
    //stripePublicKey: 'pk_test_nEpeQYFcubKLe1nWJqVJWQBY00jfld4tJg',
    gooplePlacesApiKey: 'AIzaSyAXOBXyCY90eOA46PdmtYIb_8UWCEwAmTA',
    api: 'https://api.mylighthouse.co',
    stripePublicKey: 'pk_live_ZzIihRJmiPuJp69ts92ZsUG000zpYJn9Gc',
}
